import { siteCopy, siteData } from "../copy";

/** The pages that carry their own questions (`pagefaq.<page>`, the prototype's `data-s`). */
export type PageFaqKey =
  | "home"
  | "how"
  | "abi"
  | "security"
  | "pricing"
  | "employers"
  | "about"
  | "contact";

/**
 * Per-page FAQ (the prototype's pageFaqBuild, v41): the three or four questions people arrive on a
 * page with, in a band of their own above the footer's general set. Pages put it where the
 * prototype inserts it: before the page's closing call to action (`.endcta`), or last.
 */
export function PageFaq({ page }: { page: PageFaqKey }) {
  const items = siteData<[string, string][]>(`pagefaq.${page}`);
  if (!items?.length) return null;
  return (
    <section className="band pfaqband">
      <div className="wrap" style={{ maxWidth: 860 }}>
        <h2 className="pfaqh" dangerouslySetInnerHTML={{ __html: siteCopy("pagefaq.h") }} />
        <div className="pfaq">
          {items.map(([q, a]) => (
            <details key={q}>
              <summary dangerouslySetInnerHTML={{ __html: q }} />
              <p dangerouslySetInnerHTML={{ __html: a }} />
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
